<template>
  <tr v-if="sensor" class="review-sensor">
    <td>
      {{ sensor.zoneName }}
      <div class="chips-container">
        <Chip v-for="cat in categories" :key="cat.id">
          {{ cat.name }}
        </Chip>
      </div>
    </td>
    <td>
      {{ engagedDistance }}
    </td>
    <td>
      {{ passerbyDistance }}
    </td>
    <td>
      {{ sensor.name }}<br />
      <Chip>{{ sensor.mac_address }} </Chip>
    </td>
  </tr>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { SensorDistanceSettingType, SensorZone } from '@/types/Sensor';

import Chip from '@/components/global/Chip.vue';

import { useEventsStore } from '@/stores/events';
const eventsStore = useEventsStore();

const props = defineProps<{
  sensorDistanceOptions: SensorDistanceSettingType[];
  sensor: SensorZone;
}>();

const categories = computed(() => {
  return eventsStore.eventList?.zone_category.filter((cat) => {
    return props.sensor.zoneCats?.includes(cat.id);
  });
});

const passerbyDistance = computed(() => {
  if (props.sensorDistanceOptions.length) {
    const found = props.sensorDistanceOptions.find((sens) => {
      return sens.signal_strength === props.sensor.passerby_signal;
    });
    return found?.distance_text;
  }

  return '';
});

const engagedDistance = computed(() => {
  if (props.sensorDistanceOptions.length) {
    const found = props.sensorDistanceOptions.find((sens) => {
      return sens.signal_strength === props.sensor.engaged_signal;
    });
    return found?.distance_text;
  }

  return '';
});
</script>

<style lang="scss">
.event-review-section__split .zone-list .review-sensor .chip {
  margin-left: 0;
  margin-top: variables.$vantage-base-sizing-xxxs;
}

.review-sensor__distances {
  @include mixins.flex-start($gap: variables.$vantage-base-sizing-xs);
  list-style-type: none;
  margin-top: variables.$vantage-base-sizing-xs;

  li {
    @include typography.font-body($size: sm, $weight: normal);
    color: variables.$vantage-base-primitives-color-tertiary-400;

    > div {
      @include typography.font-body($size: sm, $weight: bold);
    }
  }
}
</style>
